import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ApprovalDialogComponent } from 'src/app/dialogs/approval-dialog/approval-dialog.component';
import { MessageDialogComponent } from 'src/app/dialogs/message-dialog/message-dialog.component';
import { DataManagerService } from 'src/app/services/DataManager/data-manager.service';
import { BaseListComponent } from 'src/app/shared/abstract/base-list.component';
import { AppConstants } from 'src/app/shared/constants/app-constants';
import { HeaderConstants } from 'src/app/shared/constants/header-constants';
import { PermissionConstants } from '../shared/constants/permission-constants';
@Component({
  selector: 'app-volunteer-list',
  templateUrl: './volunteer-list.component.html',
  styleUrls: ['./volunteer-list.component.css'],
})
export class VolunteerListComponent
  extends BaseListComponent
  implements OnInit
{
  public loged_user = JSON.parse(localStorage.getItem('user') || 'null');
  deleteUrl: string;
  constructor(
    datamanagerService: DataManagerService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    super();
    this.page = 1;
    this.rows = 10;
    this.service = datamanagerService;
    this.getTableSettings();
    this.searchHits = new Subject<void>();
    this.getListUrl = AppConstants.BASE_URL + AppConstants.VOLUNTEER_URL;
    this.deleteUrl = AppConstants.BASE_URL + AppConstants.VOLUNTEER_URL;
    this.columnDefinition = HeaderConstants.volunteerListHeader;
    this.headings = 'Volunteers';
    this.delete_permission = this.permissionCheck(
      PermissionConstants.PERMISSIONS_VOLUNTEER_REMOVE,
    );
    this.permissionsCheck = {
      view_permission: true,
      delete_permission: this.delete_permission,
    };
  }
  ngOnInit(): void {
    this.loader = true;
    this.searchHits.pipe(debounceTime(600)).subscribe((res) => {
      this.loader = true;
      if (!this.isNullOrUndefined(this.searchText)) {
        console.log('serch jsjsdf', this.setUrl());
      }
    });
    this.setUrl();
  }

  onNotifySelected(selectedRows: object[]) {
    console.log(selectedRows);
  }
  protected getListRes(res: any): void {
    this.loader = true;
    this.rowData = [];
    if (res['status'] == 'success') {
      this.resultsLength = res.data.pagination.total;
      res.data.rowData.forEach((element: any, index: number) => {
        const phone = element.contact_number.match(/(\d{3})(\d{3})(\d{4})/);
        element.contact_number =
          '+1 ' + '(' + phone[1] + ') ' + phone[2] + '-' + phone[3];
      });
      this.rowData = res.data.rowData;
      console.log(this.rowData);
      this.loader = false;
    } else {
      this.loader = false;
    }
  }

  protected getListErr(err: any): void {
    console.log(err);
    this.loader = false;
  }
  getActions(data: any) {
    if (data.actions === 'delete') {
      const dialogRef = this.dialog.open(MessageDialogComponent, {
        data: {
          message: 'Do you want to delete this volunteer?',
          buttonText: {
            ok: 'Ok',
            cancel: 'Close',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          let payload = {
            ids: [data.data.id],
          };
          this.service
            .deleteRequest(this.deleteUrl + '/' + data.data.id, payload)
            .subscribe({
              next: (res: any) => {
                if (res['status'] == 'success') {
                  this.service.showSnackBar(res.message, 'ok', 3000);
                  this.router
                    .navigateByUrl('home', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([location.pathname]);
                    });
                } else {
                  this.service.showSnackBar(res.message, 'ok', 3000);
                }
              },
              error: (error) => {
                this.service.showSnackBar(error.message, 'ok', 3000);
              },
            });
        }
      });
    } else {
      this.router.navigate(['./' + data.data.id], {
        relativeTo: this.route,
      });
    }
  }

  createNew() {
    this.router.navigate(['volunteer']);
  }
}
